import * as Icons from "@/icons";
import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

export type IconName = keyof typeof Icons;

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
}

export const CustomIcon = ({
  name,
  size = 6,
  className,
  ...props
}: IconProps) => {
  const Component = Icons[name];
  if (typeof Component !== "function") return null;

  const sizeClass = size ? `size-${size}` : ""; // tailwind size-x util

  return (
    <Component
      className={cn(
        "inline-block fill-current text-gray-500",
        sizeClass,
        className
      )}
      {...props}
    />
  );
};
